export function notNullable<T>(value: T | undefined | null): value is T {
  return !!value;
}
